// extracted by mini-css-extract-plugin
export default {"PageTabs":"PageTabs_PageTabs__uZOvA","no-left-margin":"PageTabs_no-left-margin__wcpie","no-line":"PageTabs_no-line__Et+1p"};